import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  eligibleVoters: number;
  participation: number;
}

const VoterInfos = ({ eligibleVoters, participation }: Props) => {
  const { t } = useTranslation('wap');

  return (
    <div className="voterinfos">
      <div>
        <Trans t={t} i18nKey="table_eligible_voters" count={eligibleVoters}>
          <span className="voterinfos__label">eligibleVotersLabel</span>
          <span>eligibleVotersValue</span>
        </Trans>
      </div>
      <div>
        <Trans t={t} i18nKey="table_participation" count={participation}>
          <span className="voterinfos__label">participationLabel</span>
          <span>participationValue</span>
        </Trans>
      </div>
    </div>
  );
};

export default VoterInfos;
